import { styled } from '@mui/material';

export const ToggleContainer = styled('div')(({ theme }) => ({
  borderRight: '1px solid lightGray',
  paddingRight: 10,
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));
